import React from 'react'

const SendToBackIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <rect x="3" y="8" width="12" height="12" rx="1" fill={color} />
        <rect x="9" y="4" width="12" height="12" rx="1" stroke={color} strokeWidth="2" fill="none" />
    </svg>
)

export default SendToBackIcon
